import React, { Component } from 'react'
import { connect } from 'react-redux'

import { objectAttachments } from 'selectors/attachments'

import Section from 'components/Section'
import AttachButton from './AttachButton'
import AttachmentsList from './AttachmentsList'

let select = (state, props) => ({
	attachments: objectAttachments(state, props)
})

export class Attachments extends Component {
	render(){
		let { props } = this
		return(
			<Section
				id="attachments"
				title="Attachments"
				badge={props.attachments.length}
				rightButton={<AttachButton objectID={props.objectID} path={props.path}/>}
				top={props.top}
			>
				<AttachmentsList objectID={props.objectID} removable={props.removable}/>
			</Section>
		)
	}
}

export default connect(select)(Attachments)



// WEBPACK FOOTER //
// ./src/components/Attachments/index.js